import apiClient from './api';

export const dsgvoAPI = {
  exportData: () => apiClient.get('/dsgvo/export'),
  deleteData: () => apiClient.post('/dsgvo/delete'),
  cancelDeletion: () => apiClient.post('/dsgvo/cancel-deletion'),
  getDeletionStatus: () => apiClient.get('/dsgvo/deletion-status'),
  getPrivacyPolicy: () => apiClient.get('/dsgvo/privacy-policy'),
  getDataRights: () => apiClient.get('/dsgvo/data-rights'),
};

export default dsgvoAPI;
